import getBankAccount from './getBankAccount';

export default function hasUsedIav(instruments = []) {
  const bankAccount = getBankAccount(instruments);
  return !!bankAccount?.tags?.includes('iav');
}
